import { format, isAfter, isBefore, isSameDay } from 'date-fns'

import {
  DATE_FULL_FORMAT,
  DEADLINE_BG_COLOR_DEFAULT,
  DEADLINE_TEXT_COLOR_DEFAULT,
  DEADLINE_TEXT_COLOR_EARLY,
  DEADLINE_TEXT_COLOR_OVERDUE,
  DEADLINE_TEXT_COLOR_ROLLING,
} from '../../../constants/date'
import {
  REQUEST_COMPLETED_STATUS,
  REQUEST_DENIED_STATUS,
  REQUEST_IN_PROGRESS_STATUS,
  REQUEST_PENDING_STATUS,
} from '../../../constants/request'
import { getColorWithOpacity } from '../../../utils/color'

function getEntityProfileHeaderInfoItemDeadlineColorProps(deadline, status) {
  const isCloseStatus =
    status === REQUEST_COMPLETED_STATUS || status === REQUEST_DENIED_STATUS
  const isActiveStatus =
    status === REQUEST_PENDING_STATUS || status === REQUEST_IN_PROGRESS_STATUS

  const { backgroundColor, textColor } =
    isCloseStatus || !isActiveStatus
      ? {
          backgroundColor: DEADLINE_BG_COLOR_DEFAULT,
          textColor: DEADLINE_TEXT_COLOR_DEFAULT,
        }
      : getEntityProfileHeaderInfoItemDeadlineColorByDate(deadline)

  return {
    backgroundColor: backgroundColor || getColorWithOpacity(textColor),
    textColor,
  }
}

function getEntityProfileHeaderInfoItemDeadlineColorByDate(deadline) {
  const currentDate = Date.now()
  const isDeadlineDay = isSameDay(deadline, currentDate)
  const isDeadlineAfterCurrentTime = isAfter(deadline, currentDate)
  const isDeadlineBeforeCurrentTime = isBefore(deadline, currentDate)

  let textColor

  if (isDeadlineDay && isDeadlineAfterCurrentTime) {
    textColor = DEADLINE_TEXT_COLOR_ROLLING
  } else if (isDeadlineAfterCurrentTime) {
    textColor = DEADLINE_TEXT_COLOR_EARLY
  } else if (isDeadlineBeforeCurrentTime) {
    textColor = DEADLINE_TEXT_COLOR_OVERDUE
  } else {
    textColor = DEADLINE_TEXT_COLOR_DEFAULT
  }

  return { textColor }
}

export function getEntityProfileHeaderInfoItemDeadlineFormattedText(deadline) {
  return format(deadline, DATE_FULL_FORMAT)
}

export function getEntityProfileHeaderInfoItemDeadlineTagColorProps(
  deadline,
  status
) {
  return getEntityProfileHeaderInfoItemDeadlineColorProps(deadline, status)
}
